import classNames from 'classnames';
import upperFirst from 'lodash.upperfirst';
import camelCase from 'lodash.camelcase';
import isNumber from 'lodash.isnumber';
export var alignmentClassName = function (componentData, theme, styles, isMobile) {
    var _a = componentData.config || {}, alignment = _a.alignment, size = _a.size;
    if (!alignment || isMobile) {
        return '';
    }
    var align = alignment;
    if (size === 'original' && alignment !== 'center') {
        var width = (componentData.src || {}).width;
        if (isNumber(width) && width > 350) {
            align = 'center';
        }
    }
    return classNames(styles["align" + upperFirst(align)], theme["align" + upperFirst(align)]);
};
export var sizeClassName = function (componentData, theme, styles, isMobile) {
    var size = (componentData.config || {}).size;
    if (!size) {
        return theme['imagePlugin'];
    }
    if (isMobile) {
        return classNames(styles.sizeFullWidth, theme.sizeFullWidth, theme['imagePlugin']);
    }
    return classNames(styles["size" + upperFirst(camelCase(size))], theme["size" + upperFirst(camelCase(size))], theme['imagePlugin']);
};
//# sourceMappingURL=classNameStrategies.js.map